import statuses from './statuses';

export default {
  statuses,
};
